import React, { useState, useEffect, useCallback } from "react";

import ProfileAvatar from "components/__reusable/ProfileAvatar";
import { getTagStudent } from "services/pictureServices";
import type { TagStudent, UpdateTagStudentFormData } from "types/TagStudent";
import type { Picture } from "types/Pictures";
import { PictureType } from "config/constants";

interface TagStudentListProps {
  picture: Picture;
}

const TagStudentList: React.FC<TagStudentListProps> = ({ picture }) => {
  const [tagStudents, setTagStudents] = useState<TagStudent[]>([]);

  const fetchTagStudent = useCallback(async () => {
    try {
      const tagStudents = await getTagStudent(picture.id);
      setTagStudents(tagStudents);
    } catch (e) {}
  }, [picture.id]);

  useEffect(() => {
    fetchTagStudent();
  }, [fetchTagStudent]);

  const renderStudentItem = (tagStudent: TagStudent) => {
    return (
      <div
        key={tagStudent.id}
        className="flex items-center gap-1 sm:gap-1.5 p-1"
      >
        <div className="flex-shrink-0 w-6 h-6 sm:w-8 sm:h-8">
          <ProfileAvatar
            pictureUrl={tagStudent.student?.profile_picture_for_admin || ""}
            width={32}
            height={32}
          />
        </div>
        {tagStudent.student && (
          <p className="text-xs sm:text-sm font-medium text-gray-700 overflow-hidden text-ellipsis min-w-0 leading-tight">
            {renderStudentName(tagStudent.student)}
          </p>
        )}
      </div>
    );
  };

  const renderStudentName = (student: UpdateTagStudentFormData) => {
    if (student.first_name_kata && student.last_name_kata)
      return `${student.last_name} ${student.first_name}`;
    else return `${student.last_name} ${student.first_name}`;
  };

  return (
    <div className="h-full overflow-auto relative">
      <div className="w-full h-full absolute">
        <div className="flex flex-col w-full">
          {picture.picture_type === PictureType.class ? (
            <div className="flex items-center gap-2 pb-2 mb-2 border-b border-b-[#9B9B9B] w-full min-w-0">
              <div className="relative flex-shrink-0">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-gray-200 flex items-center justify-center text-base sm:text-lg font-bold text-gray-700">
                  全
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs sm:text-sm lg:text-base break-words leading-tight">
                  クラス全体
                </p>
              </div>
            </div>
          ) : (
            <div
              id="tag-students"
              className="flex flex-wrap gap-1 sm:gap-2 w-full"
            >
              {tagStudents.map((tagStudent) => renderStudentItem(tagStudent))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TagStudentList;
